export const extraVenueRegistrationIntroVenueData = {
	apiEndpoint: '/api/venueregistration/introVenueSelection/venueSearch',
	paramName: 'venueName',
	apiResponseKey: 'venue',
	dataKey: 'id',
	dataEventName: 'venueSelect',
	valueKey: 'venueName',
	venueType: 'venue',
	keepTypingLength: 0,
	searchAgainLabel: 'Search again',
	searchAgainIcon: 'search',
	addressFormElement: {
		venueName: {
			errorMessage: 'Enter a venue name',
			id: 'venue-name-address',
			label: 'Venue Name',
			hasLimit: true,
			charLimit: 3
		},
		addressLine1: {
			errorMessage: 'Enter street',
			id: 'address-line1',
			label: 'Street',
			hasLimit: true,
			charLimit: 3
		},
		addressLine2: {
			errorMessage: 'Enter city',
			id: 'address-line2',
			label: 'City',
			hasLimit: true,
			charLimit: 3
		},
		county: {
			errorMessage: 'Enter county',
			id: 'address-town',
			label: 'County',
			hasLimit: true,
			charLimit: 3
		},
		postcode: {
			errorMessage: 'Enter post code',
			id: 'address-postcode',
			label: 'Post code',
			hasLimit: true,
			charLimit: 3
		}
	}
};
